<!-- @if (productType() === "sub-product") {
  <app-edit-attributes [productId]="subProductId()" />
} -->

<!-- DIVIDER -->
<div class="my-4"></div>

<form [formGroup]="productForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
  <div class="flex flex-col gap-6 rounded-2xl bg-white p-6 shadow-sm">
    <h3 class="primaryColor text-[20px] font-[600]" i18n="@@adminEditProductTitle">Edit Product Information</h3>

    <div class="grid grid-cols-2 gap-4">
      @if (productType() !== "sub-product") {
        <div class="flex flex-col gap-2" dir="rtl">
          <label class="text-[14px] font-[500]" i18n="@@adminProductFormTitleArLabel">
            Title (Ar)
            <span class="text-danger-text">*</span>
          </label>
          <input
            type="text"
            formControlName="arabicName"
            placeholder="Enter product full name in Arabic"
            i18n-placeholder="@@adminProductFormTitleArPlaceholder"
            class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
            [class.border-red-500]="productForm.get('arabicName')?.invalid && productForm.get('arabicName')?.touched" />
          @if (productForm.get("arabicName")?.invalid && productForm.get("arabicName")?.touched) {
            <span class="text-danger-text text-[12px]">
              <!-- @if (
              productForm.get("arabicName")?.errors?.["minlength"] ||
              productForm.get("arabicName")?.errors?.["maxlength"]
            ) {
              <span i18n="@@adminProductFormErrorNameLength">Name must be between 6 and 100 characters</span>
            } -->

              @if (productForm.get("arabicName")?.errors?.["required"]) {
                <span i18n="@@product.validation.titleArRequired">Arabic title is required</span>
              }

              @if (productForm.get("arabicName")?.errors?.["maxlength"]) {
                <span i18n="@@product.validation.titleArMaxLength">Arabic title cannot exceed 255 characters</span>
              }

              @if (
                productForm.get("arabicName")?.errors?.["arabicCharacters"] &&
                !productForm.get("arabicName")?.errors?.["maxlength"]
              ) {
                <span i18n="@@product.validation.shouldBeArabic">Must contain valid Arabic characters only</span>
              }

              <!-- @if (productForm.get("arabicName")?.errors?.["arabicNameNotUnique"]) {
              <span i18n="@@adminProductFormErrorArabicNameNotUnique">
                An item with this Arabic title already exists. / يوجد صنف آخر بنفس الاسم باللغة العربية.
              </span>
            } -->
            </span>
          }
        </div>

        <div class="flex flex-col gap-2">
          <label class="text-[14px] font-[500]" i18n="@@adminProductFormTitleEnLabel">
            Title (En)
          </label>
          <input
            type="text"
            formControlName="englishName"
            placeholder="Enter product full name in English (optional)"
            i18n-placeholder="@@adminProductFormTitleEnPlaceholder"
            class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
            [class.border-red-500]="
              productForm.get('englishName')?.invalid && productForm.get('englishName')?.touched
            " />
          @if (productForm.get("englishName")?.invalid && productForm.get("englishName")?.touched) {
            <span class="validationSpan text-[12px]">
              @if (productForm.get("englishName")?.errors?.["maxlength"]) {
                <span i18n="@@product.validation.titleEnMaxLength">English title cannot exceed 255 characters</span>
              }
              @if (productForm.get("englishName")?.errors?.["englishCharacters"]) {
                <span i18n="@@product.validation.shouldBeEnglish">
                  English title must contain valid english characters
                </span>
              }
            </span>
          }
        </div>
      }

      <div class="flex flex-col gap-2" dir="rtl">
        <label class="text-[14px] font-[500]" i18n="@@adminProductFormDescArLabel">Description (Ar)</label>
        <textarea
          formControlName="descriptionAr"
          placeholder="Enter Description in Arabic"
          i18n-placeholder="@@adminProductFormDescArPlaceholder"
          rows="4"
          class="borderColor inputBg placeholderColor rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:outline-none"></textarea>

        @if (productForm.get("descriptionAr")?.invalid && productForm.get("descriptionAr")?.touched) {
          <span class="validationSpan text-[12px]">
            @if (productForm.get("descriptionAr")?.errors?.["maxlength"]) {
              <span i18n="@@product.validation.descriptionMaxLength">Description cannot exceed 2000 characters</span>
            }

            @if (
              productForm.get("descriptionAr")?.errors?.["arabicCharacters"] &&
              !productForm.get("descriptionAr")?.errors?.["maxlength"]
            ) {
              <span i18n="@@product.validation.shouldBeArabicDescription">
                Arabic description must contain valid arabic characters
              </span>
            }
          </span>
        }
      </div>

      <div class="flex flex-col gap-2">
        <label class="text-[14px] font-[500]" i18n="@@adminProductFormDescEnLabel">Description (En)</label>
        <textarea
          formControlName="descriptionEn"
          placeholder="Enter Description in English"
          i18n-placeholder="@@adminProductFormDescEnPlaceholder"
          rows="4"
          class="borderColor inputBg placeholderColor rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:outline-none"></textarea>

        @if (productForm.get("descriptionEn")?.invalid && productForm.get("descriptionEn")?.touched) {
          <span class="validationSpan text-[12px]">
            @if (productForm.get("descriptionEn")?.errors?.["maxlength"]) {
              <span i18n="@@product.validation.descriptionMaxLength">Description cannot exceed 2000 characters</span>
            }

            @if (
              productForm.get("descriptionEn")?.errors?.["englishCharacters"] &&
              !productForm.get("descriptionEn")?.errors?.["maxlength"]
            ) {
              <span i18n="@@product.validation.shouldBeEnglishDescription">
                English description must contain valid english characters
              </span>
            }
          </span>
        }
      </div>

      @if (productType() === "has-no-sub" || productType() === "sub-product") {
        <div class="flex flex-col gap-2">
          <label class="text-[14px] font-[500]" i18n="@@product.field.barcode">Barcode</label>
          <input
            type="number"
            formControlName="barcode"
            placeholder="Enter barcode"
            i18n-placeholder="@@enterBarCode"
            (keydown)="blockInvalidNumberChars($event)"
            class="borderColor inputBg placeholderColor rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:outline-none" />

          @if (productForm.get("barcode")?.invalid && productForm.get("barcode")?.touched) {
            <span class="validationSpan text-[12px]">
              @if (productForm.get("barcode")?.errors?.["barcodeNumericOnly"]) {
                <span i18n="@@product.validation.barcodeNumeric">Barcode must contain only numeric characters</span>
              }
              @if (productForm.get("barcode")?.errors?.["barcodeInvalidFormat"]) {
                <span i18n="@@product.validation.barcodeLength">Barcode should be 13 characters</span>
              }
            </span>
          }
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-[14px] font-[500]" i18n="@@adminProductFormPeoplePriceLabel">People Price</label>
          <input
            type="numeric"
            appThousandSeparator
            formControlName="peoplePrice"
            placeholder="Enter price"
            i18n-placeholder="@@adminProductFormPricePlaceholder"
            class="borderColor inputBg placeholderColor rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:outline-none" />
          @if (productForm.get("peoplePrice")?.invalid && productForm.get("peoplePrice")?.touched) {
            <span class="validationSpan text-[12px]">
              @if (productForm.get("peoplePrice")?.errors?.["min"]) {
                <span i18n="@@product.validation.peoplePriceMin">People Price must be greater than 0 if provided</span>
              }
              @if (productForm.get("peoplePrice")?.errors?.["max"]) {
                <span i18n="@@product.validation.peoplePriceMax">People Price must not exceed 1,000,000</span>
              }
            </span>
          }
        </div>

        <div class="flex flex-col gap-2">
          <label class="text-[14px] font-[500]" i18n="@@sellerDiscount">Seller Discount</label>
          <div class="borderColor inputBg placeholderColor relative w-full rounded-[6px] border-[1px] text-[14px]">
            <input
              type="number"
              formControlName="sellerDiscount"
              placeholder="Enter price"
              i18n-placeholder="@@enterSellerDiscount"
              (keydown)="blockInvalidNumberChars($event)"
              class="h-full w-full px-3 py-2 outline-none" />
            <span class="absolute top-1/2 -translate-y-1/2" [class]="isArabic ? 'left-8' : 'right-8'">%</span>
          </div>
          @if (productForm.get("sellerDiscount")?.invalid && productForm.get("sellerDiscount")?.touched) {
            <span class="validationSpan text-[12px]">
              @if (productForm.get("sellerDiscount")?.errors?.["min"]) {
                <span i18n="@@product.validation.sellerDiscountMin">Seller Discount cannot be negative</span>
              }
              @if (productForm.get("sellerDiscount")?.errors?.["max"]) {
                <span i18n="@@product.validation.sellerDiscountMax">Seller Discount cannot exceed 100%</span>
              }
              @if (productForm.get("sellerDiscount")?.errors?.["numericOnly"]) {
                <span i18n="@@product.validation.sellerDiscountInvalid">Please enter a valid percentage</span>
              }
            </span>
          }
        </div>
        <div class="flex flex-col gap-1.5">
          <label class="text-sm font-semibold text-gray-700" i18n="@@product.field.sellerPrice">Seller Price</label>
          <div class="relative cursor-not-allowed rounded-lg border border-gray-100 bg-gray-100 text-sm text-gray-500">
            <input
              type="numeric"
              appThousandSeparator
              formControlName="sellerPrice"
              readonly
              class="w-full px-3 py-2.5 outline-none" />
            <span class="absolute top-1/2 -translate-y-1/2" [class]="isArabic ? 'left-8' : 'right-8'" i18n="@@EGP">
              EGP
            </span>
          </div>
        </div>

        <div class="flex flex-col gap-2">
          <label class="text-[14px] font-[500]" i18n="@@pharmacyDiscount">Pharmacy Discount</label>
          <div class="borderColor inputBg placeholderColor relative w-full rounded-[6px] border-[1px] text-[14px]">
            <input
              type="number"
              formControlName="pharmacyDiscount"
              placeholder="Enter price"
              i18n-placeholder="@@enterPharmacyDiscount"
              (keydown)="blockInvalidNumberChars($event)"
              class="h-full w-full px-3 py-2 outline-none" />
            <span class="absolute top-1/2 -translate-y-1/2" [class]="isArabic ? 'left-8' : 'right-8'">%</span>
          </div>
          @if (productForm.get("pharmacyDiscount")?.invalid && productForm.get("pharmacyDiscount")?.touched) {
            <span class="validationSpan text-[12px]">
              @if (productForm.get("pharmacyDiscount")?.errors?.["min"]) {
                <span i18n="@@product.validation.pharmacyDiscountMin">Pharmacy Discount cannot be negative</span>
              }
              @if (productForm.get("pharmacyDiscount")?.errors?.["max"]) {
                <span i18n="@@product.validation.pharmacyDiscountMax">Pharmacy Discount cannot exceed 100%</span>
              }
              @if (productForm.get("pharmacyDiscount")?.errors?.["numericOnly"]) {
                <span i18n="@@product.validation.sellerDiscountInvalid">Please enter a valid percentage</span>
              }
            </span>
          }
        </div>
        <div class="flex flex-col gap-1.5">
          <label class="text-sm font-semibold text-gray-700" i18n="@@product.field.pharmacyPrice">Pharmacy Price</label>
          <div class="relative cursor-not-allowed rounded-lg border border-gray-100 bg-gray-100 text-sm text-gray-500">
            <input
              type="numeric"
              appThousandSeparator
              formControlName="pharmacyPrice"
              readonly
              class="w-full px-3 py-2.5 outline-none" />
            <span class="absolute top-1/2 -translate-y-1/2" [class]="isArabic ? 'left-8' : 'right-8'" i18n="@@EGP">
              EGP
            </span>
          </div>
        </div>

        <div class="flex flex-col gap-2">
          <label class="text-[14px] font-[500]" i18n="@@adminProductFormCategoryLabel">
            Category
            <span class="primaryColor">*</span>
          </label>
          <select
            formControlName="category"
            class="borderColor inputBg rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:outline-none"
            [class.border-red-500]="productForm.get('category')?.invalid && productForm.get('category')?.touched">
            <!-- <option value="" disabled i18n="@@adminProductFormSelectCategory">Select category</option> -->
            @if (productData()?.category?.id) {
              <option [value]="productData()?.category?.id" selected>
                {{ isArabic ? productData()?.category?.titleAr : productData()?.category?.titleEn }}
              </option>
            } @else {
              <option value="" disabled selected>No category for this item</option>
            }
            @for (category of categories; track category.id) {
              @if (category.id !== productData()?.category?.id) {
                <option [value]="category.id">
                  {{ isArabic ? category.titleAr : category.titleEn }}
                </option>
              }
            }
          </select>
          @if (productForm.get("category")?.invalid && productForm.get("category")?.touched) {
            <span class="primaryColor text-[12px]" i18n="@@adminProductFormErrorCategoryRequired">
              Category is required
            </span>
          }
        </div>

        <div class="flex flex-col gap-2">
          <label class="text-[14px] font-[500]" i18n="@@adminProductFormSubCategoryLabel">
            Sub Category
            <span class="primaryColor">*</span>
          </label>
          <select
            formControlName="subCategory"
            class="borderColor inputBg rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:outline-none">
            <option value="" disabled i18n="@@adminProductFormSelectSubCategory">Select sub category</option>
            @for (sub of subCategories; track sub) {
              <option [value]="sub.id">{{ isArabic ? sub.titleAr : sub.titleEn }}</option>
            }
          </select>
        </div>
      }

      @if (productType() !== "sub-product") {
        <div class="col-span-2 flex flex-col gap-2">
          <label class="text-[14px] font-[500]" i18n="@@adminProductFormMfgLabel">
            Mfg Company
            <span class="text-danger-text">*</span>
          </label>
          <select
            formControlName="mfgCompany"
            class="border-border bg-surface-subtle hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
            [class.border-red-500]="productForm.get('mfgCompany')?.invalid && productForm.get('mfgCompany')?.touched">
            @if (productData()?.mfgCompany?.id) {
              <option [value]="productData()?.mfgCompany?.id" selected>
                {{ isArabic ? productData()?.mfgCompany?.titleAr : productData()?.mfgCompany?.titleEn }}
              </option>
            } @else {
              <option value="" disabled selected>No Manufacturing company for this item</option>
            }
            @for (company of mfgCompanies; track company.id) {
              <!-- <option [value]="company.id">{{ company }}</option> -->

              @if (company.id !== productData()?.mfgCompany?.id) {
                <option [value]="company.id">
                  {{ isArabic ? company.titleAr : company.titleEn }}
                </option>
              }
            }
          </select>
        </div>
      }
    </div>

    <div class="flex flex-col gap-2">
      <label class="text-[14px] font-[500]" i18n="@@adminProductFormProfileImageLabel">
        Profile Image(s)
        <span class="primaryColor">*</span>
      </label>
      <div
        class="borderColor hoverColor flex flex-col items-center justify-center gap-2 rounded-[6px] border-2 border-dashed py-[40px]"
        [class.border-red-500]="!selectedImages.length && formSubmitted">
        <svg xmlns="http://www.w3.org/2000/svg" width="48px" height="48px" viewBox="0 0 24 24" class="svgColor">
          <path
            fill="currentColor"
            d="M11 16V7.85l-2.6 2.6L7 9l5-5l5 5l-1.4 1.45l-2.6-2.6V16zm-5 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z" />
        </svg>
        <p class="uploadText text-[14px]" i18n="@@adminProductFormUploadText">Click to upload</p>
        <p class="svgColor text-[12px]" i18n="@@adminProductFormMaxFileSize">Max file Size: 5MB</p>
        <button
          type="button"
          (click)="fileInput.click()"
          class="primaryColorBg mt-2 rounded-[6px] px-6 py-2 text-[14px] font-[500] text-white hover:cursor-pointer"
          i18n="@@adminProductFormBrowseButton">
          Browse File
        </button>
        <input
          #fileInput
          type="file"
          accept="image/png,image/jpeg"
          multiple
          (change)="onFileSelect($event)"
          class="hidden" />
      </div>
      <!-- @if (selectedImages.length > 0 || productImageUrl()?.url) { -->
      @if (productData()?.imagesFids && (productData()?.imagesFids)!.length > 0) {
        <div class="grid grid-cols-4 gap-4">
          <!-- ✅ Always show the primary/profile image separately -->
          @if (productImageUrl()?.url) {
            <div class="borderPrimaryColor relative rounded-[8px] border-2 p-2">
              <img [src]="productImageUrl()?.url" class="h-[168px] w-full rounded-[4px] object-cover" />
              <span
                class="primaryColorBg absolute top-2 left-2 rounded px-1.5 py-0.5 text-[10px] text-white"
                i18n="@@product.image.primary">
                Primary
              </span>
            </div>
          }

          <!-- ✅ Extra images (index 1+) -->
          @for (image of productImages(); track image.fid) {
            <div class="borderColor relative rounded-[8px] border p-2">
              @if (image.loading) {
                <div class="h-[168px] w-full animate-pulse rounded-[4px] bg-gray-200"></div>
              } @else if (image.error) {
                <div>
                  <!-- <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                  </svg>
                  <span class="text-[11px]" i18n="@@product.image.failedToLoad">Failed to load</span> -->
                </div>
              } @else {
                <img [src]="image.url" class="h-[168px] w-full rounded-[4px] object-cover" />
              }
              <div class="mt-2 flex items-center justify-between">
                <button
                  type="button"
                  (click)="setPrimaryImage(image.fid)"
                  class="primaryColor text-[11px] hover:cursor-pointer hover:underline"
                  i18n="@@adminProductFormImageSetPrimary">
                  Set as primary
                </button>
                <button
                  type="button"
                  [disabled]="deletingImage()"
                  (click)="updateSelectedImages(image.fid)"
                  class="primaryColor hover-text-primary-hover hover:cursor-pointer disabled:opacity-50">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2zM7 6v13z" />
                  </svg>
                </button>
              </div>
            </div>
          }
        </div>
      }

      @if (selectedImages().length > 0) {
        <div class="mt-3 grid grid-cols-4 gap-4">
          @for (img of selectedImages(); track $index) {
            <div class="borderColor relative rounded-[8px] border p-2">
              <img [src]="img.preview" class="h-[168px] w-full rounded-[4px] object-cover" />
              <div class="mt-2 flex items-center justify-between">
                <button
                  type="button"
                  (click)="removeSelectedImage($index)"
                  class="primaryColor hover-text-primary-hover cursor-pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2zM7 6v13z" />
                  </svg>
                </button>
              </div>
            </div>
          }
        </div>
      }
    </div>

    @if (productType() === "sub-product") {
      <div>
        <h2 class="primaryColor mb-6 text-[20px] font-[600]" i18n="@@attributes">Attributes</h2>
        <div>
          @if (this.productForm.get("attributes")?.value?.length === 0) {
            <!-- <app-no-data-component /> -->
            <app-empty-data
              [title]="isArabic ? 'لا يوجد مواصفات خاصة بالصنف الفرعي' : 'there is no attributes for sub product'" />
          }

          <div class="flex flex-wrap items-center justify-start gap-4">
            @if (parentProductAttributes()) {
              @for (attr of parentProductAttributes(); track attr.attributeKey.id) {
                <div class="flex w-1/4 flex-col items-start gap-2">
                  <label class="text-lg font-bold">
                    {{ isArabic ? attr.attributeKey.titleAr : attr.attributeKey.titleEn }}*
                  </label>
                  <select
                    (change)="onAttributeChange(attr.attributeKey.id, $any($event.target).value)"
                    class="borderColor w-full rounded-lg border px-3 py-1 text-sm">
                    <option value="" disabled selected>
                      {{ isArabic ? "اختر قيمة" : "Select a value" }}
                    </option>
                    @for (item of attr.attributeValues; track item.id) {
                      <option [value]="item.id">{{ isArabic ? item.titleAr : item.titleEn }}</option>
                    }
                  </select>
                </div>
              }
            }
          </div>
        </div>
      </div>
    }
  </div>

  @if (errorUpdaingProduct()) {
    <app-error [apiError]="errorUpdaingProduct()" />
  }

  <div class="flex justify-end gap-3">
    <button
      type="button"
      (click)="openConfirmationCancel()"
      class="primaryColor borderPrimaryColor hover-bg-primary-10 rounded-[6px] border px-5 py-1.5 text-[13px] font-[500] hover:cursor-pointer">
      <span i18n="@@cancel">Cancel</span>
    </button>
    <button
      type="submit"
      class="primaryColorBg rounded-[6px] px-5 py-1.5 text-[13px] font-[500] text-white hover:cursor-pointer">
      @if (loading()) {
        <span i18n="@@adminProductFormUpdating">updating...</span>
      } @else {
        <span i18n="@@adminProductFormUpdateButton">Update</span>
      }
    </button>
  </div>
</form>

@if (confirmationCancel()) {
  <app-confirmation-cancel
    (dismissed)="onCancelConfirmed()"
    [productId]="productData()?.id"
    [productType]="productType()"
    [subProductId]="subProductId()" />
}

@if (successUpdate()) {
  <app-successful-notification
    type="success"
    [title]="
      isArabic
        ? productType() === 'sub-product'
          ? 'تم تحديث الصنف الفرعي بنجاح'
          : 'تم تحديث الصنف بنجاح'
        : productType() === 'sub-product'
          ? 'Sub Product has been updated successfully!'
          : 'Product has been updated successfully.'
    " />
}
